module.exports = __webpack_public_path__ + "img/420-shop-en.1fed6767.svg";